import { Component, OnInit, TemplateRef} from '@angular/core';
import { PlanAcumulativoService } from '../../../services/plan-acumulativo.service';
import { PlanAcumulativo } from '../../../models/plan-acumulativo';
import { Caja } from '../../../models/caja';
import { CajaService } from '../../../services/caja.service';
import { SessionService } from '../../../services/session.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import * as moment from 'moment';
import { Venta } from '../../../models/venta';
import { SweetMessage } from '../../../config/sweet-message';
import { ComprobanteService } from '../../../services/comprobante.service';
import { ConfirmacionAnulacionModalComponent } from '../../modals/confirmacion-anulacion-modal/confirmacion-anulacion-modal.component';
import { VentaService } from '../../../services/venta.service';
import { CbtContadorService } from '../../../services/cbt-contador.service';
import { CobroDetalle } from '../../../models/cobro_detalle';
import { Validation } from '../../../config/validation';
import { Cobro } from '../../../models/cobro';
import { VentaDetalle } from '../../../models/venta_detalle';
import { FacturaModalComponent } from '../../modals/factura-modal/factura-modal.component';
import { ReporteModalComponent } from '../../modals/reporte-modal/reporte-modal.component';
import { PlanAcumulativoModalComponent } from '../../modals/plan-acumulativo-modal/plan-acumulativo-modal.component';
import { Router } from '@angular/router';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { PlanAcumulativoDetalle } from '../../../models/plan-acumulativo-detalle';
import { Pagination } from '../../../models/pagination';
import { ClienteService } from '../../../services/cliente.service';

@Component({
  selector: 'app-plan-acumulativo-list',
  templateUrl: './plan-acumulativo-list.component.html',
  styleUrls: ['./plan-acumulativo-list.component.css'],
  providers: [
	  PlanAcumulativoService,
	  CajaService,
	  ComprobanteService,
	  VentaService,
	  ClienteService
	]
})
export class PlanAcumulativoListComponent implements OnInit {
	public planes: Array<PlanAcumulativo>;
	// public plan_selectplaned: PlanAcumulativo;
	public detalle: Array<PlanAcumulativoDetalle>;
	public plan_selected: PlanAcumulativo;
	public loading: boolean;
	public cajas: Array<Caja>;
	public bsModalRef: BsModalRef;
	public bsModalRefFacturar: BsModalRef;
	public fecha_emision;
	public venta: Venta;
	public msgSweet: SweetMessage;
	public loadingFacturar: boolean;
	public Mod_FactElec: string;
	public vl: Validation;
	public fecha_MesAnt;
	public fecha_actual;
	public ventaIdPrinted: String;
	public isPrinted: boolean;
	public pagination: Pagination;
	public dataGrid: any;
	private q: Array<any>;
	public busqueda: String;
	public clientes_id:String; 
	public observacion: String;
	public plan_anulado: PlanAcumulativo;
	public bsModalRef2:BsModalRef;
	public msg: SweetMessage;

	constructor(
		public planAcumulativoService: PlanAcumulativoService,
		public cajaService: CajaService,
		public ss: SessionService,
		private modalService: BsModalService,
		public comprobanteService: ComprobanteService,
		public ventaService: VentaService,
		public cbtContadorService: CbtContadorService,
		private NavRoute: Router,
		private storage: AsyncLocalStorage,
		public clienteService: ClienteService,
	) {
		this.loading = false;
		this.planes = [];
		this.detalle = [];
		this.cajas = [];
		this.bsModalRef = new BsModalRef();
		this.bsModalRefFacturar = new BsModalRef();
		this.plan_selected = new PlanAcumulativo();
		this.fecha_emision = moment(this.fecha_emision);
		this.venta = new Venta();
		this.msgSweet = new SweetMessage();
		this.loadingFacturar = false;
		this.Mod_FactElec = this.ss.getData("mod_felectronica");
		this.vl = new Validation();
		this.fecha_actual = moment(this.fecha_actual);
		this.fecha_MesAnt = moment(this.fecha_actual.subtract(1, 'months'));
		this.ventaIdPrinted = "";
		this.isPrinted = false;
		this.pagination = new Pagination();
		this.q = [];
		this.busqueda = "";
		this.clientes_id = "";
	}

  	ngOnInit() {
		this.msg = new SweetMessage();  
		let p1 = this.getListPlanAcumulativo();
		let p2 = this.getCajas();

		this.loading = true;
		Promise.all([p1,p2]).then(
			res => this.loading = false,
			err => this.loading = false,
		);
	}
	

	onSearch(event){
		this.busqueda = event.target.value;
		this.loading =true;
		this.getListPlanAcumulativo().then(
			res => this.loading = false,
			err => this.loading = false
		);
		
	}
	getCliente(busqueda){
		return new Promise((resolve, reject) => { //isnull=venta_id&modalFacturarç
		
			let qs = "";
			if(busqueda){
				qs = "&q[razon_social]=" + busqueda;
			}
			this.clienteService.getAll("?sort=-id&status=A" + qs).subscribe(
				res => {
					let clientes_id = [];
					res.data.forEach( (data:any) => {
						clientes_id.push(data.id);
					  });
			
					this.clientes_id = clientes_id.join();
					
					this.pagination.current_page = 1;
					this.loading = true;
					
					resolve();
				},
				err => {
					this.planes = [];
					reject();
				}
			);
		});
	}

	getListPlanAcumulativo(){
		return new Promise((resolve, reject) => { //isnull=venta_id&
			let qs = "";
		
			if (this.busqueda != "") {
				qs = "&razon_social="+this.busqueda;
			}
			this.planAcumulativoService.getByFilter("?page="+this.pagination.current_page+"&per_page=10"+qs).subscribe(
				res => {
					this.planes = res.data;
					
					// Paginación
                    this.pagination.current_page = res.current_page;
                    this.pagination.from = res.from;
                    this.pagination.to = res.to;
                    this.pagination.total = res.total;
                    this.pagination.last_page = res.last_page;
                    this.pagination.next_disabled = (this.pagination.current_page === this.pagination.last_page);
                    this.pagination.prev_disabled = this.pagination.current_page === 1;
					resolve();
				},
				err => {
					this.planes = [];
					reject();
				}
			);
		});
	}

	getCajas(){
        return new Promise((resolve, reject ) => {
            this.cajaService.getAll("?embed=sucursal&sucursal_id=" + this.ss.getData('sucursal_id')).subscribe(
                res => {                
                    this.cajas = res.data;
                    resolve();
                },
                err => {                
                    this.cajas = [];
                    reject(err);
                }
            );
        });        
	}

	getSubtotal(plan){
		return parseFloat(plan.subtotal_iva0.toString()) + parseFloat(plan.subtotal_iva12.toString())
	}
	
	getPlanById(plan_id){
		return new Promise((resolve, reject ) => {
			this.loading = true;
			let qs = '?embed=tipocomprobante,bodega,detalle,cliente?embed=tipoidentificacion';
			this.planAcumulativoService.getById(plan_id, qs).subscribe(
				res => {
					this.loading = false;
					this.plan_selected = res.data;
					resolve();
				},
				err => {
					this.loading = false;
					reject();
				}
			);
		});  
    }

	openModalFacturar(template: TemplateRef<any>, plan) {
	//	this.plan_selected = plan;
		this.getPlanById(plan.id).then(
			res=>{
				this.venta = new Venta();
				this.ventaIdPrinted = "";
				this.isPrinted = false;
		
				//
				this.venta.tipo_comprobante_id = this.plan_selected.tipo_comprobante_id;
				this.venta.cliente_id = this.plan_selected.cliente_id;
				this.venta.cliente = this.plan_selected.cliente;
				//
		
				this.bsModalRefFacturar = this.modalService.show(template, Object.assign({backdrop: 'static'}));
			}, err =>{

			}
		);
		
	}

	
	getNumeroComprobante(){
        if( !this.venta.caja_id || !this.venta.tipo_comprobante_id){
            this.venta.numero_documento = "";
            return;
        }

        let caja = this.cajas.filter(x => x.id == this.venta.caja_id)[0];

        this.loadingFacturar = true;
        
        this.comprobanteService.getSecuencial(this.venta.tipo_comprobante_id, caja.id).subscribe(
            res => {
                this.loadingFacturar = false;
                if(res.secuencial){
                    this.venta.serie = caja.sucursal.establecimiento;
                    this.venta.punto_emision = caja.punto_emision;
                    this.venta.secuencial = res.secuencial;

                    this.venta.numero_documento = this.venta.serie + "-" + this.venta.punto_emision + "-" + this.venta.secuencial;
                }else{
                    this.venta.serie = "";
                    this.venta.punto_emision = "";
                    this.venta.secuencial = "";
                    this.venta.numero_documento = "";
                }
                //this.calcularFactura();
            },
            err => {
                this.loadingFacturar = false;
                this.venta.serie = "";
                this.venta.punto_emision = "";
                this.venta.secuencial = "";
                this.venta.numero_documento = "";
                
                this.msgSweet.showMessage('error-message', err);
            }
        );
	}

	isValidFacturar(){
		if( !this.venta.caja_id ){
			return false;
		}
		if( !this.venta.tipo_comprobante_id ){
			return false;
		}
		if( !this.venta.numero_documento ){
			return false;
		}
		if( !this.vl.validDate(this.fecha_emision.toString()) ){
            return false;
		}
		if( !this.venta.cliente_id ){
			return false;
		}
		if( this.plan_selected.estado_pago == "P" ){
			return false;
		}
		return true;
	}

	setValueFactura(){
		//VENTA
		this.venta.is_secuencial_manual = false;
		this.venta.fecha_emision = moment(this.fecha_emision).format("YYYY-MM-DD");
		this.venta.tipo = "CO";
		this.venta.tipo_venta = "menor";
		this.venta.subtotal_iva12 = this.plan_selected.subtotal_iva12;
		this.venta.subtotal_iva0 = this.plan_selected.subtotal_iva0;
		this.venta.desct_valor = this.plan_selected.desc_valor;
		this.venta.desct_porcent = 0;
		this.venta.subt_desct_iva12 = this.plan_selected.subtotal_iva12;
		this.venta.subt_desct_iva0 = this.plan_selected.subtotal_iva0;
		this.venta.iva = this.plan_selected.iva;
		this.venta.total = this.plan_selected.total;
		this.venta.abonado = this.plan_selected.abonado;
		this.venta.cliente_id = this.plan_selected.cliente_id;
		this.venta.cliente = this.plan_selected.cliente;
		this.venta.bodega_id = this.plan_selected.bodega_id;
		this.venta.usuario_id = this.ss.getData('usuario_id');
        this.venta.empresa_id = this.ss.getData('empresa_id');
		this.venta.sucursal_id = this.ss.getData('sucursal_id');

		//VENTA DETALLE
		this.plan_selected.detalle.forEach(plandetalle => {
			let venta_detalle = new VentaDetalle();
			venta_detalle.cantidad = plandetalle.cantidad;
			venta_detalle.precio_unitario = plandetalle.precio_unitario;
			venta_detalle.desc_valor = plandetalle.desc_valor;
			venta_detalle.desc_porcent = 0;
			venta_detalle.subtotal = plandetalle.subtotal;
			venta_detalle.iva = plandetalle.iva;
			venta_detalle.total = plandetalle.total;
			venta_detalle.porct_iva = plandetalle.porct_iva;
			venta_detalle.total = plandetalle.total;
			venta_detalle.detalle = plandetalle.detalle;
			venta_detalle.producto_id = plandetalle.producto_id;
			venta_detalle.usuario_id = this.ss.getData('usuario_id');
			venta_detalle.empresa_id = this.ss.getData('empresa_id');
			venta_detalle.sucursal_id = this.ss.getData('sucursal_id');

			this.venta.detalle.push(venta_detalle);
		});

		//Cobro
		let cobro = new Cobro();
		//cobro.tipo_doc = "FAC";
        //cobro.tipo_documento_id = (this.tipo=="VE"?this.venta.id:this.plan.id);
		cobro.fecha_cobro = moment(this.fecha_emision).format("YYYY-MM-DD");
        cobro.detalle = [];
        cobro.saldo = this.venta.total;
        cobro.recibido = this.venta.abonado;
        cobro.cambio = 0;
        cobro.empresa_id = this.ss.getData("empresa_id");
        cobro.sucursal_id = this.ss.getData("sucursal_id");
        cobro.usuario_id = this.ss.getData("usuario_id");

		//Cobro detalle
		let cobro_detalle = new CobroDetalle();

		cobro_detalle.valor = this.venta.abonado;
		cobro_detalle.forma_pago_id = "4"; // PLAN ACUMULATIVO
		cobro_detalle.empresa_id = this.ss.getData("empresa_id");
		cobro_detalle.sucursal_id = this.ss.getData("sucursal_id");
		cobro_detalle.usuario_id = this.ss.getData("usuario_id");

		cobro.detalle.push(cobro_detalle);

		this.venta.cobros.push(cobro);
	}
	//////
	setVentaElectronica(venta: Venta){
        let ventaElectronica = {};
        ventaElectronica['datos'] = {};
        ventaElectronica['datos']['infoTributaria'] = {};
        ventaElectronica['datos']['infoTributaria']['ambiente'] = "";
        ventaElectronica['datos']['infoTributaria']['tipoEmision'] = 1;
        ventaElectronica['datos']['infoTributaria']['razonSocial'] = "";
        ventaElectronica['datos']['infoTributaria']['ruc'] = this.ss.getData('emp_ruc');
        ventaElectronica['datos']['infoTributaria']['claveAcceso'] = "";
        ventaElectronica['datos']['infoTributaria']['codDoc'] = "01"; //Factura
        ventaElectronica['datos']['infoTributaria']['estab'] = venta.serie;
        ventaElectronica['datos']['infoTributaria']['ptoEmi'] = venta.punto_emision;
        ventaElectronica['datos']['infoTributaria']['secuencial'] = venta.secuencial.toString().padStart(9,"0");
        ventaElectronica['datos']['infoTributaria']['dirMatriz'] = ""; //this.ss.getData('emp_direccion');

        ventaElectronica['datos']['infoFactura'] = {};
        ventaElectronica['datos']['infoFactura']['fechaEmision'] =  moment(venta.fecha_emision).format("DD/MM/YYYY");
        ventaElectronica['datos']['infoFactura']['dirEstablecimiento'] = this.ss.getData('sucursal_direccion');
        ventaElectronica['datos']['infoFactura']['tipoIdentificacionComprador'] = venta.cliente.tipoidentificacion.cod_dni;
        ventaElectronica['datos']['infoFactura']['razonSocialComprador'] = venta.cliente.razon_social.toString().replace("&","Y");
        ventaElectronica['datos']['infoFactura']['identificacionComprador'] = venta.cliente.dni;

        let totalSinImpuestos = 0;
        venta.detalle.forEach(item => {
            totalSinImpuestos += Math.round(item.subtotal * 100) / 100;
        });

        ventaElectronica['datos']['infoFactura']['totalSinImpuestos'] = totalSinImpuestos;
        ventaElectronica['datos']['infoFactura']['totalDescuento'] = venta.desct_valor;

        ventaElectronica['datos']['infoFactura']['totalConImpuestos'] = [];
        if(venta.subtotal_iva0 > 0){
            let totalConImpuestos = {};
            totalConImpuestos['codigo'] = 2;
            totalConImpuestos['codigoPorcentaje'] = 0;
            totalConImpuestos['descuentoAdicional'] = (Math.round(venta.desct_valor * 100) / 100);
            totalConImpuestos['baseImponible'] = (Math.round(venta.subtotal_iva0 * 100) / 100);
            totalConImpuestos['valor'] = "0.00";

            ventaElectronica['datos']['infoFactura']['totalConImpuestos'].push(totalConImpuestos);
        }

        if(venta.subtotal_iva12 > 0){
            let totalConImpuestos = {};
            totalConImpuestos['codigo'] = 2;
            totalConImpuestos['codigoPorcentaje'] = 2;
            totalConImpuestos['descuentoAdicional'] = (Math.round(venta.desct_valor * 100) / 100);
            totalConImpuestos['baseImponible'] = (Math.round(venta.subtotal_iva12 * 100) / 100);
            totalConImpuestos['valor'] = (Math.round(venta.iva * 100) / 100);

            ventaElectronica['datos']['infoFactura']['totalConImpuestos'].push(totalConImpuestos);
        }

        ventaElectronica['datos']['infoFactura']['propina'] = "0.00";
        ventaElectronica['datos']['infoFactura']['importeTotal'] = (Math.round(venta.total * 100) / 100);
        ventaElectronica['datos']['infoFactura']['moneda'] = "DOLAR";

		ventaElectronica['datos']['infoFactura']['pagos'] = [];
		
		//20 => OTROS
		let pago = {};
		pago["formaPago"] = "20";
		pago["total"] = (Math.round(venta.total * 100) / 100);
		pago["plazo"] = "0";
		pago["unidadTiempo"] = "DIAS";
		ventaElectronica['datos']['infoFactura']['pagos'].push(pago);

        ventaElectronica['datos']['detalles'] = [];
        venta.detalle.forEach((item) => {
            let detalle = {};
            let detalle_item = item.detalle.toString().replace(/\n/g,", ");

            detalle['codigoPrincipal'] = (item.codigo).replace(/\//g,'-');
            detalle['codigoAuxiliar'] = (item.codigo).replace(/\//g,'-');
            detalle['descripcion']  = (item.producto + (item.detalle.length>0?" - " + detalle_item:"")).replace(/\//g,'-');
            detalle['cantidad'] = item.cantidad;
            detalle['precioUnitario'] = (Math.round(item.precio_unitario * 100) / 100);
            detalle['descuento'] = (Math.round(item.desc_valor * 100) / 100);
            detalle['precioTotalSinImpuesto'] = (Math.round(item.subtotal * 100) / 100);
            detalle['impuestos'] = [];
            let impuesto = {};
            impuesto['codigo'] = 2;
            impuesto['codigoPorcentaje'] = (item.iva > 0 ? 2 : 0 );
            impuesto['tarifa'] = (item.iva  > 0 ? 12 : 0 );
            impuesto['baseImponible'] = (Math.round(item.subtotal * 100) / 100);
            impuesto['valor'] = Math.round(item.iva * 100) / 100;
            detalle['impuestos'].push(impuesto);
            ventaElectronica['datos']['detalles'].push(detalle);
        });
        
        ventaElectronica['datos']['infoAdicional'] = [];
        let adicional = {};
        adicional['Email'] = venta.cliente.correo.toString(); //this.cliente.correo;
        adicional['Direccion'] = venta.cliente.direccion.replace(/\//g,'-');

        let telefono = "0999999999";
        if( venta.cliente.telefono.toString().trim().length > 0 ){
            telefono = venta.cliente.telefono.toString();
        }
        if( venta.cliente.celular.toString().trim().length > 0 ){
            telefono = venta.cliente.celular.toString();
        }
        adicional['Telefono'] = telefono;

        /*this.datos.forEach(dato => {
            adicional[dato.descripcion.toString()] = dato.valor.toString();
        });*/

        ventaElectronica['datos']['infoAdicional'].push(adicional);

        return ventaElectronica;
    }
	//////
	
	guardarFactura(){
		let preg = "¿Está seguro de confirmar la venta?";
        const initialState = { Pregunta: preg, Respuesta:false };
        this.bsModalRef = this.modalService.show(ConfirmacionAnulacionModalComponent, Object.assign({}, {initialState}));
        
        this.bsModalRef.content.action.take(1).subscribe((Respuesta) => {
            if(Respuesta == true){
				this.setValueFactura();
				this.venta.json_string = this.setVentaElectronica(this.venta);

                if( this.Mod_FactElec ){
                    if( this.venta.cliente.es_contribuyente ){
                        if( this.venta.cliente.num_contribuyente.toString().trim().length === 0 ){
                            this.msgSweet.showMessage('error-message', "El cliente no consta con número de contribuyente");
                            return false;
                        }
                    }
                    if(this.venta.total >= 200 && this.venta.cliente.id == "1"){
                        this.msgSweet.showMessage('error-message', "No puede realizar una venta cuyo monto supere los $200 a Consumidor Final");
                        return false;
                    }

                    this.venta.json_string = this.setVentaElectronica(this.venta);
                }

                //this.cliente.correo = this.correos.toString();
                
                this.loadingFacturar = true;
                this.ventaService.save(this.venta).subscribe(
                    res => {
						this.ventaIdPrinted = res.id;

						let data = {
							id : this.plan_selected.id,
							venta_id : this.ventaIdPrinted,
							usuario_id : this.ss.getData('usuario_id'),
							empresa_id : this.ss.getData('empresa_id'),
							sucursal_id : this.ss.getData('sucursal_id'),
						};
						
						this.planAcumulativoService.update(data).subscribe(
							res => {
								this.loadingFacturar = false;
                        
								if( this.Mod_FactElec ){
									this.cbtContadorService.actualizarContador();
								}
								this.isPrinted = true;
								this.venta = new Venta();

								this.msgSweet.showMessage('success-message', 'Se ha procesado correctamente');
							},
							err => {
								this.loadingFacturar = false;
                        	this.msgSweet.showMessage('error-message',err);
							}
						);
                    },
                    err => {
                        this.loadingFacturar = false;
                        this.msgSweet.showMessage('error-message',err);
                    }
                );
            }
        });
	}

	onChangeFecha(event){
        if(event < this.fecha_MesAnt){
            this.msgSweet.showMessage('error-message', "No puede seleccionar fechas anteriores al mes");            
        }
	}
	
	onPrint(){
        if( this.isPrinted && !this.Mod_FactElec ){
			this.imprimirFactura();
		}else{
			this.imprimitCbtVenta();
		}
	}
	
	imprimirFactura(){
		const initialState = {venta_id: this.ventaIdPrinted};
		this.bsModalRef = this.modalService.show(FacturaModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
	}

    imprimitCbtVenta(){
        const initialState = {route: "cbtventa/" + this.ventaIdPrinted, qs: "?dbname=" + this.ss.getData('dbname') + "&factid=" + this.ss.getData('fact_id') + "&facttk=" + this.ss.getData('fact-api-token')};
		this.bsModalRef = this.modalService.show(ReporteModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
	}
	
	onShow(id){
		const initialState = {plan_id: id};
		this.bsModalRef = this.modalService.show(PlanAcumulativoModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
	}

	getEstado(plan: PlanAcumulativo){
		return plan.estado_pago=="P"?"PENDIENTE":"COBRADO";
	}

	onPay(id, tipo){
		this.NavRoute.navigate(['/cobro/cobro/' + tipo + '/' + id]);
	}

	closeModalFacturar(){
		this.bsModalRefFacturar.hide();

		this.loading = true;
		this.getListPlanAcumulativo().then(
			res => this.loading = false,
			err => this.loading = false,
		);
	}

	onEdit(data) {
		this.storage.setItem("plan-acumulativo", data).subscribe(() => {
			this.NavRoute.navigate(['/ventas/planacumulativo/edit']);
		});
	}

	next(){
        this.pagination.current_page++;
		this.getListPlanAcumulativo();
	}

	prev(){
		this.pagination.current_page--;
		this.getListPlanAcumulativo();
	}

	first(){
		this.pagination.current_page = 1;
		this.getListPlanAcumulativo();
	}

	last(){
		this.pagination.current_page = this.pagination.last_page;
		this.getListPlanAcumulativo();
	}
	
	getIndexNumber(i){
        return this.pagination.from+i;
	}

	openModalObservacion(template: TemplateRef<any>, plan: PlanAcumulativo) {
		this.observacion = plan.observacion;
		this.plan_anulado = plan;
		this.bsModalRef = this.modalService.show(template);
		this.bsModalRef2 = this.bsModalRef;
	}

	anularPlan(){
		this.bsModalRef2.hide();
		let preg = "¿Está seguro de querer eliminar el documento?";
		const initialState = { Pregunta: preg, Respuesta:false };
		this.bsModalRef = this.modalService.show(ConfirmacionAnulacionModalComponent, Object.assign({}, {initialState}));

		this.bsModalRef.content.action.take(1).subscribe((Respuesta) => {
			if(Respuesta == true){
				this.plan_anulado.observacion = this.observacion.toString().trim();
				this.plan_anulado.usuario_id = this.ss.getData("usuario_id");
				this.observacion  = "";
				
				this.loading = true;

				this.planAcumulativoService.anular(this.plan_anulado).subscribe(
					res => {
						this.bsModalRef.hide();
						this.plan_anulado = new PlanAcumulativo();

						this.msg.showMessage('success-message', 'Se ha procesado correctamente');

						this.getListPlanAcumulativo().then(
							res => {
								this.loading = false;
							},
							err => {
								this.loading = false;
							}
						);
					},
					err => {
						this.loading = false;
					}
				);
			}
			else{
				return;
			}
		});
	}
	
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/ventas/plan-acumulativo-list/plan-acumulativo-list.component.ts